import script from "./editView.vue?vue&type=script&setup=true&lang=js"
export * from "./editView.vue?vue&type=script&setup=true&lang=js"

import "./editView.vue?vue&type=style&index=0&id=377b6856&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-377b6856"]])

export default __exports__